import { SectionNode } from "@/domains/v4b/site-section/site-section.types";

/**
 * since the sections tree includes 2 different types of objects (site & sections)
 * the tree data can either be a section node or a site (null), without section data
 */
export type TSiteSectionsTreeData = SectionNode | null;

export function sectionHasAppliances(section: TSiteSectionsTreeData): boolean {
  return Object.values(section?.applianceCountByCategory ?? []).some((count) => count > 0);
}

export type TOpenedCreateSectionDrawerMethod = "root_button" | "tree_view";
